/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 기본 예외클래스를 정의한다.
 *
 * @file /src/exceptions/Base.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 6. 1.
 */
import { Results } from '@utils/Ajax';
import { LanguageText } from '@utils/Language';

export class Base extends Error {
    /**
     * 에러코드
     */
    code: string = null;

    /**
     * 에러클래스를 정의한다.
     *
     * @param cause - 원본 에러객체
     */
    constructor(cause: unknown = null) {
        super(undefined, { cause });
    }

    /**
     * 에러코드를 변경한다.
     *
     * @param code - 에러코드
     * @returns 예외클래스
     */
    setCode(code: string): this {
        this.code = code;
        return this;
    }

    /**
     * 에러데이터를 가져온다.
     *
     * @returns 에러데이터
     */
    getErrors(): { [key: string]: any } {
        return null;
    }

    /**
     * 에러응답객체를 가져온다.
     *
     * @returns 에러응답객체
     */
    getResponse(): Results {
        return null;
    }

    /**
     * 에러메시지를 가져온다.
     *
     * @returns 에러메시지
     */
    getMessage(): LanguageText {
        if (this.cause instanceof Error) {
            return this.cause.message;
        } else if (this.cause !== null && this.cause !== undefined) {
            return String(this.cause);
        }
        return this.message;
    }
}
